import { useEffect, useState } from "react";

export function useScoreAnimation(
  score: number,
  delay: number = 3000,
  duration: number = 600
) {
  const [displayScore, setDisplayScore] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsVisible(true);
      const startTime = Date.now();

      const animateScore = () => {
        const elapsed = Date.now() - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const easeOutQuart = 1 - Math.pow(1 - progress, 4);
        const currentScore = Math.round(score * easeOutQuart);

        setDisplayScore(currentScore);

        if (progress < 1) {
          requestAnimationFrame(animateScore);
        }
      };

      requestAnimationFrame(animateScore);
    }, delay);

    return () => clearTimeout(timeout);
  }, [score, delay, duration]);

  return { displayScore, isVisible };
}
